import { Button, Card, CardContent, CardHeader, CardTitle, Dialog, DialogContent } from 'randmarcomps';
import { SalesData as ApiSalesData } from 'randmar-api-client';
import React, { useMemo, useState } from "react";
import { FormattedNumber } from 'react-intl';
import CurrencyUtils from '../../components/util/CurrencyUtils';
import { SalesData as LegacySalesData } from '../../stores/manufacturer/Manufacturer';
import SalesSummary from './SalesSummary';

interface SalesLast30DaysProps {
  fiscalYearMonthStart?: number;
  salesData?: LegacySalesData | ApiSalesData;
}

const isLegacySalesData = (sd: LegacySalesData | ApiSalesData | undefined): sd is LegacySalesData => !!sd && 'salesLast30Days' in sd;

const convertLegacySalesDataToApiSalesData = (legacySalesData: LegacySalesData): ApiSalesData => ({
  SalesLast30Days: legacySalesData.salesLast30Days,
  SalesLast3Months: legacySalesData.salesLast3Months,
  SalesYearToDay: legacySalesData.salesYearToDay,
});

const SalesLast30Days: React.FC<SalesLast30DaysProps> = ({ fiscalYearMonthStart, salesData: rawSalesData }) => {
  const [open, setOpen] = useState(false);

  const salesData: ApiSalesData | undefined = useMemo(() => {
    if (isLegacySalesData(rawSalesData)) {
      return convertLegacySalesDataToApiSalesData(rawSalesData);
    }
    return rawSalesData;
  }, [rawSalesData]);

  return (
    <>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Sales (Last 30 Days)</CardTitle>
        </CardHeader>
        <CardContent>
          <Button variant="link" onClick={() => setOpen(true)} className="h-auto p-0 text-2xl font-bold">
            <FormattedNumber value={salesData?.SalesLast30Days || 0} {...CurrencyUtils.format} />
          </Button>
        </CardContent>
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-4xl">
          <SalesSummary salesData={salesData} fiscalYearMonthStart={fiscalYearMonthStart} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SalesLast30Days;
